export default "__VITE_ASSET__fcfefc4d__"